export default {
      id: "notifications_warning-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications_warning",
      toString: function () {
        return this.url;
      }
    }